<template>
  <div :class="[
    'item-progress-bar-wrapper',
    picklist.Tour.length ? 'item-progress-tour-inside' : '',
    `item-progress-date-${picklist.DatumStatus}`,
    'item-progress-bar-wrapper'
  ]">
    <div class="item-progress-bar mr-n4">
      <div class="item-operator-info " v-if="picklist.Tour.length">
        <div class="item-tour-info" v-if="picklist.Tour.length">
          <v-chip size="small" :color="picklist.StatusColor" variant="flat">
            <v-icon size="small" start>mdi-truck-delivery-outline</v-icon>
            <div>
              <b v-for="tour in picklist.Tour" :key="tour.Tournr">Tour {{ tour.Tournr }}</b>
            </div>
          </v-chip>
        </div>
        <div class="item-operator-info-inner">
          <v-list-item-subtitle>
            <small><b class="px-4">Ankunft</b></small>
            <div class="item-prio px-0 text-small">
              <div class="item-prio-label" style="display:flex;justify-content:center;">
                <small>{{ TourdatumvonTime }}</small>
              </div>
            </div>
          </v-list-item-subtitle>
        </div>
      </div>
      <div class="item-operator-info" style="flex: 1;">
        <div class="item-operator-info-inner">
          <v-chip class="bg-white" variant="outlined" dense :color="picklist.StatusColor"
            :class="`${picklist.StatusColor} pl-1 `">
            <v-avatar :color="`${picklist.StatusColor}`" small><b><small>{{ picklist.Kmsbediener }}</small></b>
            </v-avatar>
            <div class="ml-2 item-prio">
              <div>
                <div>
                  <small><b>{{ picklist.StatusName }}</b></small>
                </div>
                <div class="px-0">
                  <div class="item-prio-label">
                    <small>{{ picklist.KmsdatumDate }}
                      {{ picklist.Kmsuhrzeit }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <v-icon end>mdi-{{ picklist.StatusIcon }}</v-icon>
          </v-chip>
        </div>
      </div>
      <div
        v-if="picklist.Tour.length && picklist.StatusCode === 'done' || picklist.Tour.length && picklist.DatumStatus === 'active'"
        class="item-operator-info">
        <div class="item-operator-info-inner">
          <v-list-item-subtitle>
            <small>
              <b class="px-3">Abfahrt</b>
            </small>
            <div class="item-prio px-0 text-small">
              <div class="item-prio-label" style="display:flex;justify-content:center;">
                <small>{{ TourdatumbisTime }}</small>
              </div>
            </div>
          </v-list-item-subtitle>
        </div>
      </div>
    </div>
    <div v-if="picklist.DatumStatus === 'passed' && picklist.StatusCode !== 'done'"
      :class="['date-status', `date-status-${picklist.DatumStatus}`]">
      <v-chip color="error" variant="outlined">
        <div class="date-status-inner">
          <div>
            <small>
              <b class="pr-1">verpasst</b>
            </small>
            <div class="item-prio px-0 text-small">
              <div class="item-prio-label" style="display:flex;justify-content:center;">
                <small class="pr-2">{{ TourdatumbisTime }}</small>
              </div>
            </div>
          </div>
        </div>
        <v-icon size="small">mdi-clock-alert</v-icon>
      </v-chip>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, computed} from 'vue';
import Picklist from '@/model/Picklist';

export default defineComponent({
  name: 'PicklistProgress',
  components: {},
  props: {
    picklist: {
      type: Picklist,
      required: true,
    },
  },
  setup(props) {
    const KmsdatumTime = computed((): string => {
      return props.picklist.KmsdatumParsed.format('LT');
    });
    const TourdatumvonTime = computed((): string | undefined => {
      return props.picklist.Tour[0]?.TourdatumvonParsed.format('LT');
    });
    const TourdatumbisTime = computed((): string | undefined => {
      return props.picklist.Tour[0]?.TourdatumbisParsed.format('LT');
    });

    return {
      KmsdatumTime,
      TourdatumvonTime,
      TourdatumbisTime,
    };
  },
});
</script>

<style lang="scss" scoped>
.item-prio {
  overflow: visible;
  line-height: 1;

  .item-prio-label {
    width: 100%;
  }
}

.item-prio-chip {
  width: 100%;
  height: 1px !important;
  position: relative;
}

.v-chip .v-icon {
  font-size: 16px;
}

.item-body {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .item-title {
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
}

.item-operator-info {
  display: flex;
  justify-content: stretch;
  align-items: center;
  text-align: center;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  flex: auto;

  .v-chip__content {
    display: block;
  }

  .primary,
  .orange,
  .success {
    color: #fff;
  }

  .grey {
    color: #333;
  }

  .v-chip {
    text-align: left;
  }

  .item-operator-info-inner {
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex: auto;

    .v-list-item__subtitle {
      font-size: 12px;
      line-height: 1;
      overflow: visible;
    }
  }
}

.item-footer {
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
}

.v-list-item {
  display: block;
  overflow: hidden;
}

.v-chip.theme--light {
  &.red {
    color: #fff;
  }
}

.v-chip.v-size--default {
  font-size: 12px;
}

.item-progress-bar {
  display: flex;
  align-items: center;
  z-index: 1;
}

.item-progress-bar-wrapper {
  display: flex;
}

.v-application .text-grey-lighten-4 {
  color: #333 !important;
}

.v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: #fff !important;
}

.date-status-inner {
  display: flex;
  align-items: center;

  small {
    display: block;
  }

  .item-prio-label {
    position: relative;
    top: -4px;
  }
}

.date-status {
  position: relative;
  z-index: 0;
  margin-top: auto;
  margin-bottom: auto;
  text-align: left;
  margin-left: -10px;

  .v-chip {
    padding-left: 32px;
    padding-right: 8px;

  }

  .item-prio-label {
    justify-content: flex-start !important;
  }
}

.item-progress-tour-inside {
  &.item-progress-date-active {
    display: block;
  }

  .item-progress-bar {
    flex: 1;
  }
}</style>

